import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cardPayment: 'Card payment',
    cashDeposit: 'Cash deposit',
    checkPayment: 'Check payment',
    from: 'From',
    fromWallet: 'From',
    mainAccount: 'Main account',
    payinLabel: '{sender}** to **{targetBankAccount}**',
    payoutLabel: 'From **{targetBankAccount}** to **{receiver}**',
    payoutLabelWallet: 'From **{targetBankAccount}** to **{receiver}**',
    to: 'To',
    toWallet: 'To',
  },
  fr: {
    cardPayment: 'Paiement par carte',
    cashDeposit: 'Dépôt d’espèces',
    checkPayment: 'Paiement par chèque',
    from: 'De',
    fromWallet: 'Depuis',
    mainAccount: 'Compte principal',
    payinLabel: '{sender}** sur **{targetBankAccount}**',
    payoutLabel: 'De **{targetBankAccount}** à **{receiver}**',
    payoutLabelWallet: 'De **{targetBankAccount}** vers **{receiver}**',
    to: 'À',
    toWallet: 'Vers',
  },
} as const);

export default locales;
